import React from 'react';
import { Button, Container, Modal } from 'react-bootstrap';
import DraggableModal from '../UI/DraggableModal';

function ModalDescription({
  show, headerText, children, onClose,
}) {
  return (
    <DraggableModal show={show} centered onHide={onClose} headerNode={headerText}>

      <Modal.Body>
        {children}
      </Modal.Body>

      <Modal.Footer style={{ paddingRight: '1.55rem' }}>
        <Button onClick={onClose} variant="outline-primary">ОК</Button>
      </Modal.Footer>
    </DraggableModal>
  );
}

export default ModalDescription;
